import { openToast } from '../dialogs/toast';

export function coming_soon() {
	openToast('Feature coming soon!');
}
